<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-links">
          <span class="footer-link">Do Not Sell</span>
          <span class="separator">&</span>
          <span class="footer-link">Privacy Policy</span>
          <span class="separator">&</span>
          <span class="footer-link">Terms & Conditions</span>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>

<style scoped>
.footer {
  background: #f8f9fa;
  padding: 2rem 0;
  border-top: 1px solid #e9ecef;
}

.footer-content {
  text-align: center;
}

.footer-links {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.footer-link {
  color: #666;
  font-size: 0.9rem;
  text-decoration: underline;
  cursor: default;
}

.separator {
  color: #666;
  font-size: 0.9rem;
  margin: 0 0.3rem;
}

/* Responsive Design */
@media (max-width: 768px) {
  .footer {
    padding: 1.5rem 0;
  }

  .footer-links {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    gap: 0.5rem;
  }

  .separator {
    display: inline;
    margin: 0 0.3rem;
  }

  .footer-link {
    font-size: 0.85rem;
  }
}

@media (max-width: 480px) {
  .footer {
    padding: 1rem 0;
  }

  .footer-links {
    gap: 0.3rem;
  }

  .footer-link {
    font-size: 0.7rem;
  }

  .separator {
    font-size: 0.7rem;
    margin: 0 0.2rem;
  }
}
</style>
